import { useEffect } from "react";
import Cursor from "../components/ifgl/Cursor";
import Hero from "../components/ifgl/Hero";
import Manifesto from "../components/ifgl/Manifesto";
import RoleApplication from "../components/ifgl/RoleApplication";
import Counter from "../components/ifgl/Counter";
import Footer from "../components/ifgl/Footer";

const Landing = () => {
  useEffect(() => {
    document.body.classList.add("ifgl-landing");
    return () => document.body.classList.remove("ifgl-landing");
  }, []);

  return (
    <main
      data-testid="ifgl-landing"
      className="relative min-h-screen bg-black text-cotton font-condensed"
    >
      <Cursor />
      <Hero />
      <Manifesto />
      <RoleApplication />
      <Counter />
      <Footer />
    </main>
  );
};

export default Landing;
